import React from "react";

const Image = (props) => {
  return <img alt={props.alt || ""} {...props} />;
};

export default Image;
